const redConfig = [
  {
    checkPoint: "付款条件",
    companyStandard: "收货后30天",
    type: "radio",
    name: "paymentTerms",
    options: [
      { value: 1, label: "有" },
      { value: 0, label: "没有" },
    ],
  },
  {
    checkPoint: "最低起订量",
    companyStandard: "没有要求",
    type: "radio",
    name: "minimumOrderQuantity",
    options: [
      { value: 1, label: "有" },
      { value: 0, label: "没有" },
    ],
  },
  {
    checkPoint: "质量标准",
    companyStandard: "符合公司要求",
    type: "radio",
    name: "qualityStandard",
    options: [
      { value: 1, label: "有" },
      { value: 0, label: "没有" },
    ],
  },
  {
    checkPoint: "收货标准",
    companyStandard: "符合生产要求",
    type: "radio",
    name: "receivingStandard",
    options: [
      { value: 1, label: "有" },
      { value: 0, label: "没有" },
    ],
  },
  {
    checkPoint: "供应商延期罚款",
    companyStandard: "0.1%每天/符合当地合同法",
    type: "radio",
    name: "supplierDelayPenalty",
    options: [
      { value: 1, label: "有" },
      { value: 0, label: "没有" },
    ],
  },
  {
    checkPoint: "BF延期罚款",
    companyStandard: "建议没有",
    type: "radio",
    name: "bfDelayPenalty",
    options: [
      { value: 1, label: "有" },
      { value: 0, label: "没有" },
    ],
  },
  {
    checkPoint: "对供应商违约处罚",
    companyStandard: "建议有",
    type: "radio",
    name: "penaltyForSupplierBreach",
    options: [
      { value: 1, label: "有" },
      { value: 0, label: "没有" },
    ],
  },
  {
    checkPoint: "对BF违约处罚",
    companyStandard: "建议没有",
    type: "radio",
    name: "penaltyForBfBreach",
    options: [
      { value: 1, label: "有" },
      { value: 0, label: "没有" },
    ],
  },
  {
    checkPoint: "提前终止处罚",
    companyStandard: "没有/双方对等",
    type: "radio",
    name: "earlyTerminationPenalty",
    options: [
      { value: 1, label: "有" },
      { value: 0, label: "没有" },
    ],
  },
  {
    checkPoint: "保密协议",
    companyStandard: "合同有保密条款",
    type: "radio",
    name: "confidentialityAgreement",
    options: [
      { value: 1, label: "有" },
      { value: 0, label: "没有" },
    ],
  },
];

const blueConfig = [
  {
    checkPoint: "合约范围",
    companyStandard: "与URS一致",
    type: "radio",
    name: "scopeOfWork",
    options: [
      { value: 1, label: "与URS一致" },
      { value: 0, label: "部分与URS不一致，但用户确认接受" },
    ],
  },
  {
    checkPoint: "预付款",
    companyStandard: "少于30%",
    type: "input",
    name: "advancePayment",
    unit: "%",
  },
  {
    checkPoint: "进度款",
    companyStandard: "合同中应有约定",
    type: "input",
    name: "progressPayment",
    unit: "%",
  },
  {
    checkPoint: "最后一次付款",
    companyStandard: "不得少于5%",
    type: "input",
    name: "lastPayment",
    unit: "%",
  },
  {
    checkPoint: "验收条款",
    companyStandard: "符合预期要求",
    type: "radio",
    name: "acceptanceTerms",
    options: [
      { value: 1, label: "有" },
      { value: 0, label: "没有" },
    ],
  },
  {
    checkPoint: "质保期",
    companyStandard: "至少12个月",
    type: "input",
    name: "warrantyPeriod",
  },
  {
    checkPoint: "供应商延期罚款",
    companyStandard: "0.1%每天/符合当地合同法",
    type: "radio",
    name: "vendorDelayPenalty",
    options: [
      { value: 1, label: "有" },
      { value: 0, label: "没有" },
    ],
  },
  {
    checkPoint: "BF延期罚款",
    companyStandard: "建议没有",
    type: "radio",
    name: "bfDelayPenalty",
    options: [
      { value: 1, label: "有" },
      { value: 0, label: "没有" },
    ],
  },
  {
    checkPoint: "对供应商违约处罚",
    companyStandard: "建议有",
    type: "radio",
    name: "violationPenaltyToVendor",
    options: [
      { value: 1, label: "有" },
      { value: 0, label: "没有" },
    ],
  },
  {
    checkPoint: "对BF违约处罚",
    companyStandard: "建议没有",
    type: "radio",
    name: "violationPenaltyToBf",
    options: [
      { value: 1, label: "有" },
      { value: 0, label: "没有" },
    ],
  },
  {
    checkPoint: "提前终止处罚",
    companyStandard: "没有/双方对等",
    type: "radio",
    name: "earlyTerminationPenalty",
    options: [
      { value: 1, label: "有" },
      { value: 0, label: "没有" },
    ],
  },
  {
    checkPoint: "保密协议",
    companyStandard: "合同有保密条款",
    type: "radio",
    name: "confidentialAgreement",
    options: [
      { value: 1, label: "有" },
      { value: 0, label: "没有" },
    ],
  },
];

export const purpleConfig = [
  {
    checkPoint: "合约范围",
    companyStandard: "与URS一致",
    type: "radio",
    name: "scopeOfWork",
    options: [
      { value: 1, label: "与URS一致" },
      { value: 0, label: "部分与URS不一致，但用户确认接受" },
    ],
  },
  {
    checkPoint: "预付款",
    companyStandard: "少于30%",
    type: "input",
    name: "advancePayment",
    unit: "%",
  },
  {
    checkPoint: "进度款",
    companyStandard: "验收通过之后少于65%",
    type: "input",
    name: "progressPayment",
    unit: "%",
  },
  {
    checkPoint: "质保款",
    companyStandard: "不得少于5%",
    type: "input",
    name: "warrantyMoney",
    unit: "%",
  },
  {
    checkPoint: "保险",
    companyStandard:
      "覆盖110%（设施、设备、仪器）；已包括雇员补偿和第三者责任险（NP和工程建设）",
    type: "radio",
    name: "insurance",
    options: [
      { value: 1, label: "包括" },
      { value: 0, label: "不包括" },
      { value: 2, label: "其他" },
    ],
    showRemarkWhenOther: true,
    remarkFieldName: "insuranceRemark",
    otherValue: 2,
  },
  {
    checkPoint: "验收条款",
    companyStandard: "符合预期要求",
    type: "radio",
    name: "acceptanceTerms",
    options: [
      { value: 1, label: "有" },
      { value: 0, label: "没有" },
    ],
  },
  {
    checkPoint: "收货标准",
    companyStandard: "符合URS要求",
    type: "radio",
    name: "acceptanceRequirement",
    options: [
      { value: 1, label: "有" },
      { value: 0, label: "没有" },
    ],
  },
  {
    checkPoint: "质保期",
    companyStandard: "至少12个月",
    type: "input",
    name: "warrantyPeriod",
  },
  {
    checkPoint: "培训",
    companyStandard: "应包括",
    type: "radio",
    name: "training",
    options: [
      { value: 1, label: "有" },
      { value: 0, label: "没有" },
    ],
  },
  {
    checkPoint: "供应商延期罚款",
    companyStandard: "0.1%每天/符合当地合同法",
    type: "radio",
    name: "vendorDelayPenalty",
    options: [
      { value: 1, label: "有" },
      { value: 0, label: "没有" },
    ],
  },
  {
    checkPoint: "BF延期罚款",
    companyStandard: "建议没有",
    type: "radio",
    name: "bfDelayPenalty",
    options: [
      { value: 1, label: "有" },
      { value: 0, label: "没有" },
    ],
  },
  {
    checkPoint: "对供应商违约处罚",
    companyStandard: "建议有",
    type: "radio",
    name: "violationPenaltyToVendor",
    options: [
      { value: 1, label: "有" },
      { value: 0, label: "没有" },
    ],
  },
  {
    checkPoint: "对BF违约处罚",
    companyStandard: "建议没有",
    type: "radio",
    name: "violationPenaltyToBf",
    options: [
      { value: 1, label: "有" },
      { value: 0, label: "没有" },
    ],
  },
  {
    checkPoint: "提前终止处罚",
    companyStandard: "没有/双方对等",
    type: "radio",
    name: "earlyTerminationPenalty",
    options: [
      { value: 1, label: "有" },
      { value: 0, label: "没有" },
    ],
  },
];

export const checklistConfig = {
  red: redConfig,
  blue: blueConfig,
  purple: purpleConfig,
};
